import instance from './instance';

export const fetchUserBySlug = uuid => instance.get(`/users/${uuid}`);

export const updateUser = (id, data) => instance.put(`/users/${id}`, data);

export const updateUserPhoto = data => instance.putForm('/users/update_user_avatar', data);

export const updateUserFlag = data => instance.put('/users/set_flag', data);

export const createAddToWaitlist = ({ id, data }) => instance.post(`/users/${id}/add_to_waitlist`, data);
